export default {
  fr: {
    fields: {
      maximum_charge: "charge maximale",
      dimensions: "dimensions",
      id: "ID",
    },
  },
};
